import React, { useState, useEffect, useRef, useContext } from 'react';
import { AnalyticType } from '../../model/AnalyticType';
import { TimeLapse } from '../../model/TimeLapse';
import { ChartDataset } from '../../model/ChartDataset';
import { LineChart } from '../charts/LineChart';
import { BarChart } from '../charts/BarChart';
import { HistoricalService } from '../../model/Historical';
import { Filter } from '../../model/Filter';
import { AccountContext } from '../../contexts/AccountContext';
import { MultiAxisLineChart } from '../charts/MultiAxisLineChart';
import { ISaleService } from '../../services/ISaleService';

const HistoricalChart = ({ primaryOption, secondaryOption, timeLapse, filter, saleService }: Props) => {
  const historicalServiceRef = useRef(new HistoricalService(saleService));
  const [datasets, setDatasets] = useState<ChartDataset[]>([]);
  const [labels, setLabels] = useState<string[]>([]);
  const params = useContext(AccountContext);

  useEffect(() => {
    const refresh = async () => {
      const input = await historicalServiceRef.current.getChartInput(primaryOption, secondaryOption, timeLapse, filter, params);
      setDatasets(input.datasets);
      setLabels(input.labels);
    }
    refresh();
  }, [ primaryOption, secondaryOption, timeLapse, filter ]);

  if(primaryOption !== AnalyticType.age && primaryOption !== AnalyticType.gender && secondaryOption !== AnalyticType.age && secondaryOption !== AnalyticType.gender) {
    return !secondaryOption ?
      <LineChart datasets={datasets} labels={labels} height={310} displayAxes={true} /> :
      <MultiAxisLineChart datasets={datasets} labels={labels} height={310} displayAxes={true} />
  }
  else {
    return <BarChart datasets={datasets} labels={labels} displayGrid={false} displayY={true} height={310} />
  }
}

interface Props {
  primaryOption: AnalyticType,
  secondaryOption: AnalyticType | undefined,
  timeLapse: TimeLapse,
  filter: Filter,
  saleService: ISaleService
}

export { HistoricalChart };

